import React, { Component } from 'react';
// import { hot } from 'react-hot-loader/root';
import { HashRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import { getRouterData } from './web';
import __ from 'lodash';
import qs from 'query-string';
import './styles.module.scss';
import AppHelper from '../libs/AppHelper';
import history from '../libs/history';
import NotificationCenter, { NotificationName } from '../libs/NotificationCenter';
import { wConnectRedux } from '../reducers';
import 'styles/app.module.scss';
// import LayoutFactory from '../layouts/Layout/LayoutFactory';
const _ = __
class App extends Component {
  componentDidMount() {
    const { auth } = this.props
    
    if (auth && auth.isLogin)
    {
      AppHelper.updateUserInfo()
    }

    // auth異動
    this.authDeniedToken = NotificationCenter.default.addObserver(this, (notification) => {
      this.props.cleanUserInfo && this.props.cleanUserInfo()
      this.props.cleanAuthInfo && this.props.cleanAuthInfo()
      history.push('/login')
    }, NotificationName.AuthDenied)
    // auth異常
    this.authDeniedToken = NotificationCenter.default.addObserver(this, (notification) => {
      console.log('PermissionsDidChanged', notification)
      this.forceUpdate()
    }, NotificationName.PermissionsDidChanged)
  }

  componentWillUnmount() {
    NotificationCenter.default.removeObserver(this)
  }

  render()
  {
    const user = _.get(this,'props.user')
    const roles = _.get(this, 'props.user.roles',[])
    
    // 此處可簡單處理轉導功能
    // if (user.isLogin === false && window.location.pathname !== '/')
    //   history.replace('/')

    const search = _.get(window,'location.search')
    
    const queryParams = qs.parse(search)

    const slug = _.get(queryParams, 'page')
    
    // 此處不使用Route原本Path的功能
    // 改看wp-admin/admin.php?page=stores
    
    return (
      <Router>
        <Switch>
          { getRouterData()
            .filter(router => _.isNil(router.wp_slug) || router.wp_slug === slug)
            .map(router => {
              // let Layout = LayoutFactory.create(router.layout, router)
              // let routerSetting = {...router, component:null}
              let routerSetting = { ...router}
              return (
                <Route 
                  key={router.path} 
                  {...routerSetting} 
                  // render={() => <Layout {...router} componentView={router.component}/>}
                />
              )
          })}
        </Switch>
      </Router>
    );
  }    
}

export default wConnectRedux(App)

// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)



// WEBPACK FOOTER //
// ./src/routes/App.js